import { QueryPage } from '@@ting/services/api/query-hooks'
import { InfiniteData } from 'react-query'

const getFlatDataFromPages = (data: InfiniteData<QueryPage<any>>) =>
  data?.pages?.[0] !== undefined ? data.pages?.map(page => page?.data)?.flat() : []

export default getFlatDataFromPages
